export default {
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
  ERROR: "error",
};
